<template>
  <div class="addCompetitionManagement">
    <div class="topTitle"><span @click="goback">返回</span> / 新增比赛</div>
    <div class="table">
      <el-form
        label-position="top"
        :rules="rules"
        ref="contest"
        :model="contest"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="比赛名称" required prop="title">
              <el-input
                v-model="contest.title"
                placeholder="请输入比赛名称"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="描述" required prop="description">
              <Tinymce v-model="contest.description"></Tinymce>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开始时间" required prop="start_date">
              <el-date-picker
                v-model="contest.start_date"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择时间"
                placement="bottom-start"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束时间" required prop="end_date">
              <el-date-picker
                v-model="contest.end_date"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择时间"
                placement="bottom-start"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="报名方式" required prop="sign_mode">
              <el-select
                class="difficulty-select"
                size="small"
                v-model="contest.sign_mode"
                style="width:100%"
              >
                <el-option label="自由报名" :value="1"></el-option>
                <el-option label="报名审核" :value="2"></el-option>
                <el-option label="由组织方拉人" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="比赛赛制" required prop="rule_type">
              <el-radio class="radio" v-model="contest.rule_type" :label="1"
                >ACM</el-radio
              >
              <el-radio class="radio" v-model="contest.rule_type" :label="2"
                >OI</el-radio
              >
              <el-radio class="radio" v-model="contest.rule_type" :label="3"
                >IOI</el-radio
              >
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可选编程语言">
              <el-checkbox-group v-model="contest.languages">
                <el-checkbox
                  v-for="item in languagess"
                  :label="item.id"
                  :key="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="实时排名" prop="rank_state">
              <el-switch v-model="contest.rank_state" active-color="" inactive-color="">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="post_state">
              <el-switch v-model="contest.post_state" active-text="" inactive-text="">
              </el-switch>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <!-- <el-form-item label="允许的 IP 范围">
              <div v-for="(range, index) in contest.allowed_ip_ranges" :key="index">
                <el-row :gutter="20" style="margin-bottom: 15px">
                  <el-col :span="8">
                    <el-input v-model="range.value" placeholder="CIDR网络"></el-input>
                  </el-col>
                  <el-col :span="10">
                    <el-button plain icon="el-icon-plus" @click="addIPRange"></el-button>
                    <el-button plain icon="el-icon-delete-solid" @click="removeIPRange(range)"></el-button>
                  </el-col>
                </el-row>
              </div>
            </el-form-item> -->
            <!-- <el-form-item label="公告">
              <el-input type="textarea" v-model="contest.notic"></el-input>
            </el-form-item> -->
          </el-col>
        </el-row>
      </el-form>
      <el-button type="primary" @click="save('contest')"> 保存比赛 </el-button>
    </div>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import { adminAddOrUpdateOjContest } from '@/api/adminOj.js'

export default {
  components: {
    Tinymce,
  },
  data() {
    return {
      difficultyId: '',
      contest: {
        rule_type: 1,
        title: '',
        description: '',
        start_date: '',
        end_date: '',
        post_state: true,
        rank_state: true,
        sign_mode: '',
        notic: '',
        languages: ['0', '1', '2'],
      },
      //可选编程语言
      languagess: [
        {
          id: '0',
          name: 'C',
        },
        {
          id: '1',
          name: 'C++',
        },
        {
          id: '2',
          name: 'Python3',
        },
      ],
      rules: {
        title: [
          {
            required: true,
            message: '请输入题目名称',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入题目名称',
            trigger: 'blur',
          },
        ],

        start_date: [
          {
            required: true,
            message: '开始时间',
            trigger: 'change',
          },
          {
            required: true,
            message: '结束时间',
            trigger: 'blur',
          },
        ],
        description: [
          {
            required: true,
            message: '请输入题单描述',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入题单描述',
            trigger: 'blur',
          },
        ],
        // post_state: [
        //   {
        //     required: true,
        //     message: "请选择开启状态",
        //     trigger: "change",
        //   },
        //   {
        //     required: true,
        //     message: "请选择开启状态",
        //     trigger: "blur",
        //   },
        // ],
        // rank_state: [
        //   {
        //     required: true,
        //     message: "请选择排名状态",
        //     trigger: "change",
        //   },
        //   {
        //     required: true,
        //     message: "请选择排名状态",
        //     trigger: "blur",
        //   },
        // ],
        sign_mode: [
          {
            required: true,
            message: '请选择报名方式',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择报名方式',
            trigger: 'blur',
          },
        ],
        rule_type: [
          {
            required: true,
            message: '请选择模式',
            trigger: 'change',
          },
          {
            required: true,
            message: '请选择模式',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    this.contest = JSON.parse(this.$route.query.row)
    console.log(this.contest, 123465)
    this.contest.rank_state = JSON.parse(this.$route.query.row).rank_state
    this.contest.post_state = JSON.parse(this.$route.query.row).post_state
    this.contest.languages = JSON.parse(this.contest.languages)

    this.difficultyId = JSON.parse(this.$route.query.row).id
  },
  methods: {
    save(formName) {
      if (this.contest.languages.length === 0) {
        this.$message.warning('请至少选择一直语言')
        return false
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.difficultyId) {
            console.log(123, 45)
            adminAddOrUpdateOjContest({
              languages: JSON.stringify(this.contest.languages),
              id: this.difficultyId,
              title: this.contest.title,
              description: this.contest.description,
              start_date: this.contest.start_date,
              end_date: this.contest.end_date,
              post_state: this.contest.post_state,
              rank_state: this.contest.rank_state,
              sign_mode: this.contest.sign_mode,
              rule_type: this.contest.rule_type,
              notic: this.contest.notic,
            }).then((res) => {
              console.log(res, 33321)
              this.$message.success('修改比赛成功!')

              this.goback()
            })
          } else {
            adminAddOrUpdateOjContest({
              languages: JSON.stringify(this.contest.languages),
              title: this.contest.title,
              description: this.contest.description,
              start_date: this.contest.start_date,
              end_date: this.contest.end_date,
              post_state: this.contest.post_state,
              rank_state: this.contest.rank_state,
              sign_mode: this.contest.sign_mode,
              rule_type: this.contest.rule_type,
              notic: this.contest.notic,
            }).then((res) => {
              console.log(res, 33321)
              this.$message.success('新建比赛成功!')
              this.goback()
            })
          }
        }
      })
    },
    chanegState(val) {
      console.log(val)
      if (val === true) {
        this.contest.rank_state = '1'
      } else {
        this.contest.rank_state = '0'
      }
      console.log(this.contest.rank_state)
    },
    chanegPostState(val) {
      if (val === true) {
        this.contest.post_state = '1'
      } else {
        this.contest.post_state = '0'
      }
    },
    // addIPRange() {
    //   this.contest.allowed_ip_ranges.push({ value: '' })
    // },
    // removeIPRange(range) {
    //   let index = this.contest.allowed_ip_ranges.indexOf(range)
    //   if (index !== -1) {
    //     this.contest.allowed_ip_ranges.splice(index, 1)
    //   }
    // },
    goback() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.addCompetitionManagement {
  height: 100%;
  width: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  cursor: pointer;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.table {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}
</style>
